import Rest from '../Rest'

export default class SubgroupNewsService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/subgroup_news'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  cloneBySubgroup(id: Number, data: any = null) {
    return this.post(`/${id}/newsletters/clone_by_subgroup`, data)
  }
}
